/* VanillaGoods Kids Kitchen (sections/kk-hub.liquid, kk-recipes.liquid). Reads assets/kids-kitchen-recipes.json once.
   Hub: "Find my first baking project". Catalog: cards + chips (?band= ?treat= ?time= ?nobake=1 ?hide=egg,milk).
   Nothing about the child is stored; analytics events carry counts only. ASCII only (emoji as \u escapes). */
(function () {
  'use strict';
  var root = document.getElementById('kk');
  if (!root || !root.getAttribute('data-kk-data')) return;

  var BANDS = {
    little_helpers: { name: 'Little Helpers', ages: '4 to 6', icon: '\ud83c\udf31' },
    junior_bakers: { name: 'Junior Bakers', ages: '7 to 10', icon: '\ud83e\udd63' },
    rising_chefs: { name: 'Rising Chefs', ages: '11 to 14', icon: '\ud83e\uddc1' }
  };
  var TREATS = { cupcakes: 'Cupcakes', cookies: 'Cookies & brownies', cakes: 'Cakes', no_bake: 'No-bake treats',
                 muffins_breads: 'Muffins, breads & pastry', breakfast: 'Breakfast', frozen: 'Frozen treats' };
  var JOBS = {
    oven: ['\ud83d\udd25', 'Oven'], stovetop: ['\ud83c\udf73', 'Stove'], microwave: ['\u26a1', 'Microwave'],
    electric_mixer: ['\ud83c\udf00', 'Mixer'], blender: ['\ud83e\udd64', 'Blender'], food_processor: ['\u2699\ufe0f', 'Food processor'],
    sharp_knife: ['\ud83d\udd2a', 'Knife'], hot_pan: ['\u2668\ufe0f', 'Hot pan'], boiling_water: ['\ud83d\udca7', 'Boiling water'], toaster: ['\ud83c\udf5e', 'Toaster']
  };
  var ALLERGENS = { wheat: 'wheat', egg: 'egg', milk: 'milk', peanuts: 'peanuts', tree_nuts: 'tree nuts', soy: 'soy', sesame: 'sesame' };

  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function track(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* none */ } }
  function img(u, w) { return u ? esc(u) + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w : ''; }
  function mins(r) { var m = r.minutes || 0; return m ? (m >= 120 ? Math.round(m / 60) + ' hr' : m + ' min') : ''; }

  function jobIcons(list) {
    return (list || []).map(function (j) {
      var x = JOBS[j];
      return x ? '<span class="kk-icon" title="Grown-up job: ' + esc(x[1]) + '"><span aria-hidden="true">' + x[0] + '</span>' + esc(x[1]) + '</span>' : '';
    }).join('');
  }
  function bandPill(b) {
    var x = BANDS[b];
    return x ? '<span class="kk-pill kk-pill--' + b + '"><span aria-hidden="true">' + x.icon + '</span> ' + esc(x.name) + '</span>' : '';
  }
  function card(r) {
    var jobs = (r.grown_up || []).length ? '<p class="kk-jobs"><b>Grown-up help</b> <span class="kk-icons">' + jobIcons(r.grown_up) + '</span></p>'
      : '<p class="kk-jobs"><b>Grown-up help</b> Bake with a grown-up nearby.</p>';
    var allergens = (r.allergens || []).map(function (a) { return ALLERGENS[a] || a; }).join(', ');
    return '<li class="kk-card"><a href="' + esc(r.url) + '" tabindex="-1" aria-hidden="true"><img src="' + img(r.image, 480) +
      '" alt="" loading="lazy" width="480" height="360"></a><div class="kk-card__body">' +
      '<div class="kk-pills">' + bandPill(r.band) + (r.no_bake ? '<span class="kk-pill kk-pill--nobake">No-bake</span>' : '') + '</div>' +
      '<h3><a href="' + esc(r.url) + '">' + esc(r.title) + '</a></h3>' +
      '<p class="kk-meta">' + esc(TREATS[r.treat] || '') + (mins(r) ? ' \u00b7 ' + mins(r) : '') + '</p>' + jobs +
      (allergens ? '<p class="kk-meta">Contains: ' + esc(allergens) + '</p>' : '') +
      (r.raw_dough ? '<p class="kk-meta">No tasting the raw dough.</p>' : '') + '</div></li>';
  }

  function hub(recipes) {
    var form = $('[data-kk-finder]'), out = $('[data-kk-pick]');
    if (!form || !out) return;
    var seen = [];
    function pick(another) {
      var band = (form.querySelector('input[name="band"]:checked') || {}).value || 'junior_bakers';
      var exp = (form.querySelector('input[name="exp"]:checked') || {}).value || 'first';
      var treat = (form.querySelector('input[name="treat"]:checked') || {}).value || 'any';
      var pool = recipes.filter(function (r) { return r.band === band; });
      var byTreat = pool.filter(function (r) { return treat === 'any' || r.treat === treat; });
      if (byTreat.length) pool = byTreat;
      pool.sort(function (a, b) {
        var fa = exp === 'first' ? (b.first_bake || 0) - (a.first_bake || 0) : 0;
        return fa || (a.ingredients || 99) - (b.ingredients || 99) || (a.minutes || 999) - (b.minutes || 999);
      });
      if (!another) seen = [];
      var r = pool.filter(function (x) { return seen.indexOf(x.handle) < 0; })[0];
      if (!r) { seen = []; r = pool[0]; }
      if (!r) { out.innerHTML = '<p class="kk-empty">No match yet. Try another treat.</p>'; return; }
      seen.push(r.handle);
      var b = BANDS[r.band] || {};
      out.innerHTML = '<div class="kk-pick"><img src="' + img(r.image, 600) + '" alt="" width="600" height="450"><div>' +
        '<p class="kk-meta">' + esc(b.name || '') + ' \u00b7 ages ' + esc(b.ages || '') + (mins(r) ? ' \u00b7 ' + mins(r) : '') + '</p>' +
        '<h3>' + esc(r.title) + '</h3><p>' + esc(r.why || '') + '</p>' +
        '<p class="kk-jobs"><b>You do</b> ' + esc(r.kid_jobs || '') + '</p>' +
        ((r.grown_up || []).length ? '<p class="kk-jobs"><b>Grown-up help</b> <span class="kk-icons">' + jobIcons(r.grown_up) + '</span></p>' : '') +
        '<p style="margin-top:12px;display:flex;gap:10px;flex-wrap:wrap"><a class="kk-btn" href="' + esc(r.url) + '">Let\u2019s bake it</a>' +
        (pool.length > 1 ? '<button type="button" class="kk-btn kk-btn--light" data-kk-another>Show me another</button>' : '') + '</p></div></div>';
      var again = out.querySelector('[data-kk-another]');
      if (again) again.addEventListener('click', function () { pick(true); });
    }
    form.addEventListener('change', function () { pick(false); });
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    pick(false);
  }

  function catalog(recipes) {
    var form = $('[data-kk-filters]'), list = $('[data-kk-cards]');
    if (!form || !list) return;
    var count = $('[data-kk-count]'), none = $('[data-kk-none]'), legend = $('[data-kk-legend]');
    var present = {}, usedJobs = {};
    recipes.forEach(function (r) {
      (r.allergens || []).forEach(function (a) { present[a] = 1; });
      (r.grown_up || []).forEach(function (j) { usedJobs[j] = 1; });
    });
    $$('[data-kk-allergen]', form).forEach(function (l) { l.hidden = !present[l.getAttribute('data-kk-allergen')]; });
    if (legend) legend.innerHTML = '<b>Grown-up jobs:</b> ' + Object.keys(JOBS).filter(function (j) { return usedJobs[j]; })
      .map(function (j) { return '<span class="kk-icon"><span aria-hidden="true">' + JOBS[j][0] + '</span>' + esc(JOBS[j][1]) + '</span>'; }).join(' ');

    var p = new URLSearchParams(location.search);
    function setRadio(name, v) { var el = form.querySelector('input[name="' + name + '"][value="' + (v || '').replace(/"/g, '') + '"]'); if (el) el.checked = true; }
    setRadio('band', p.get('band') || ''); setRadio('treat', p.get('treat') || ''); setRadio('time', p.get('time') || '');
    if (p.get('nobake') === '1' && form.elements.nobake) form.elements.nobake.checked = true;
    (p.get('hide') || '').split(',').forEach(function (a) {
      var el = form.querySelector('input[name="hide"][value="' + a.replace(/"/g, '') + '"]');
      if (el && !el.closest('[hidden]')) el.checked = true;
    });

    function state() {
      var v = function (n) { return (form.querySelector('input[name="' + n + '"]:checked') || {}).value || ''; };
      return { band: v('band'), treat: v('treat'), time: v('time'), nobake: !!(form.elements.nobake && form.elements.nobake.checked),
               hide: $$('input[name="hide"]:checked', form).map(function (i) { return i.value; }) };
    }
    function apply(fromUser) {
      var s = state();
      var rows = recipes.filter(function (r) {
        if (s.band && r.band !== s.band) return false;
        if (s.treat && r.treat !== s.treat) return false;
        var m = r.minutes || 0;
        if (s.time === '30' && !(m && m <= 30)) return false;
        if (s.time === '60' && !(m && m <= 60)) return false;
        if (s.time === '61' && !(m > 60)) return false;
        if (s.nobake && !r.no_bake) return false;
        for (var i = 0; i < s.hide.length; i++) if ((r.allergens || []).indexOf(s.hide[i]) >= 0) return false;
        return true;
      });
      list.innerHTML = rows.map(card).join('');
      if (count) count.textContent = rows.length + ' of ' + recipes.length + ' recipe' + (recipes.length === 1 ? '' : 's');
      if (none) none.hidden = rows.length > 0;
      var q = new URLSearchParams();
      if (s.band) q.set('band', s.band); if (s.treat) q.set('treat', s.treat); if (s.time) q.set('time', s.time);
      if (s.nobake) q.set('nobake', '1'); if (s.hide.length) q.set('hide', s.hide.join(','));
      try { history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q : '')); } catch (e) { /* ignore */ }
      if (fromUser) track('kk_filter', { band: s.band || 'all', treat: s.treat || 'all', time: s.time || 'any', results: rows.length });
    }
    form.addEventListener('change', function () { apply(true); });
    apply(false);
  }

  fetch(root.getAttribute('data-kk-data'), { credentials: 'omit' }).then(function (r) {
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return r.json();
  }).then(function (d) {
    var recipes = (d && Array.isArray(d.recipes) ? d.recipes : []).filter(function (r) { return r && r.title && r.url; });
    hub(recipes);
    catalog(recipes);
  }).catch(function () {
    var box = $('[data-kk-pick]') || $('[data-kk-cards]');
    if (box) box.innerHTML = '<p class="kk-empty">The recipes could not load right now. <a href="/pages/recipes">Browse all recipes</a>.</p>';
  });
})();
